export default __webpack_public_path__ + "static/media/image.inotrend-int-.24800b9b.png";